'use client';

import { useLottie } from 'lottie-react';

const LottieAnimation = ({ animationData }: any) => {

  const style = {
    width: '100%',
    height: '100%',
  }

  const { View } = useLottie({
    animationData,
    loop: true,
    style,
    preload: "auto",
  });

  return View;
};

export default LottieAnimation;